import { Helmet } from 'react-helmet-async'

const Meta = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
    </Helmet>
  )
}

Meta.defaultProps = {
  title: 'ShopWave | Curated commerce, beautifully delivered',
  description: 'Discover polished products, smooth checkout, and curated ecommerce finds on ShopWave.',
  keywords: 'ecommerce, curated products, premium shopping, online store',
}

export default Meta
